<script lang="ts">
  import type { Meta } from "types/backend/models/cms/meta.entity";
  export let meta: Meta;
  $: ({ name, content } = meta);
</script>

<svelte:head>
  {#if name && content}
    <meta {name} {content} />
  {/if}
</svelte:head>
